import N8nIcon from './Icon.vue';

export default N8nIcon;
